module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [(_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.err) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-stepper', {
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 1,
      "step": "1"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.companyInfo))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 2,
      "step": "2"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.companySettings))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.account))])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid1),
      callback: function($$v) {
        _vm.valid1 = $$v
      },
      expression: "valid1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.header.companyGeneralData) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.name,
      "placeholder": _vm.$lang.placeholders.companyName,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyName)); }],
      "type": "text",
      "id": "name",
      "required": "",
      "hint": _vm.company.name.length > 12 ? 'Name will be shortened on webshop in mobile view' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.email,
      "placeholder": _vm.$lang.placeholders.companyEmail,
      "type": "email",
      "id": "email",
      "required": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.company.email),
      callback: function($$v) {
        _vm.$set(_vm.company, "email", $$v)
      },
      expression: "company.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationNumber,
      "type": "text",
      "id": "registrationNumber"
    },
    model: {
      value: (_vm.company.registrationNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationNumber", $$v)
      },
      expression: "company.registrationNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.phone,
      "placeholder": _vm.$lang.placeholders.phone,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyPhone)); }],
      "required": "",
      "type": "text",
      "id": "phone"
    },
    model: {
      value: (_vm.company.phone),
      callback: function($$v) {
        _vm.$set(_vm.company, "phone", $$v)
      },
      expression: "company.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationLocation,
      "type": "text",
      "id": "registrationLocation"
    },
    model: {
      value: (_vm.company.registrationLocation),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationLocation", $$v)
      },
      expression: "company.registrationLocation"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "required",
    attrs: {
      "rules": [_vm.company.cuisines.length !== 0 || ("" + (_vm.$lang.errors.missingCuisines))],
      "required": "",
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "items": _vm.cuisines,
      "label": _vm.$lang.labels.cuisines
    },
    model: {
      value: (_vm.company.cuisines),
      callback: function($$v) {
        _vm.$set(_vm.company, "cuisines", $$v)
      },
      expression: "company.cuisines"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.header.companyAddress) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.country,
      "placeholder": _vm.$lang.placeholders.companyCountry,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyCountry)); }],
      "items": _vm.countries,
      "type": "text",
      "id": "country",
      "required": ""
    },
    model: {
      value: (_vm.company.address.country),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "country", $$v)
      },
      expression: "company.address.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    attrs: {
      "block": "",
      "disabled": _vm.company.address.country === ''
    },
    on: {
      "click": function($event) {
        _vm.addressDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.addressLookup) + "\n                    ")])], 1), _vm._v(" "), (_vm.company.address.latitude && _vm.company.address.longitude) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "rest-desc text-xs-left"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.selectedAddress) + ":")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.generateAddress([
    _vm.company.address.line1,
    _vm.company.address.line2,
    _vm.company.address.line3,
    _vm.company.address.line4 ])))]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.company.address.locality ? _vm.company.address.locality + ', ' : '') + "\n                        " + _vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.townCity : _vm.company.address.postalCode) + ",\n                        " + _vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.postalCode : _vm.company.address.townCity) + "\n                      ")])])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "to": {
        name: 'logIn'
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid1 || !_vm.addressSet,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.next) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid2),
      callback: function($$v) {
        _vm.valid2 = $$v
      },
      expression: "valid2"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.header.companySettings) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.dailyOrdersCounterEnabled
    },
    model: {
      value: (_vm.company.dailyOrdersCounterEnabled),
      callback: function($$v) {
        _vm.$set(_vm.company, "dailyOrdersCounterEnabled", $$v)
      },
      expression: "company.dailyOrdersCounterEnabled"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-4": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.paymentTypes,
      "placeholder": _vm.$lang.placeholders.paymentTypes,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "items": _vm.payments,
      "required": "",
      "rules": [_vm.company.paymentTypes.length > 0 || ("" + (_vm.$lang.errors.missingPayments))]
    },
    model: {
      value: (_vm.company.paymentTypes),
      callback: function($$v) {
        _vm.$set(_vm.company, "paymentTypes", $$v)
      },
      expression: "company.paymentTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingHours
    },
    on: {
      "click": _vm.addHours
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.actions.openingHours) + "\n                    ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [(_vm.openingTimes.length !== 0) ? _c('thead', [_c('tr', [_c('td', {
    staticClass: "move-row"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.day)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.start)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.end)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.openingTimes), function(time, index) {
    return _c('tr', {
      key: index
    }, [(time.isEdit) ? [_c('td', {
      staticClass: "move-row"
    }), _vm._v(" "), _c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.days
      },
      model: {
        value: (_vm.tempOpening.day),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "day", $$v)
        },
        expression: "tempOpening.day"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.start),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "start", $$v)
        },
        expression: "tempOpening.start"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.end),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "end", $$v)
        },
        expression: "tempOpening.end"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.saveOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.save) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.copy) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.cancel) + "\n                                ")])], 1)] : [_c('td', {
      staticClass: "move-row"
    }, [(_vm.openingTimes.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up\n                                  ")]) : _vm._e(), _vm._v(" "), (index != _vm.openingTimes.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down\n                                  ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.day))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.end))]), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": _vm.editingHours
      },
      on: {
        "click": function($event) {
          return _vm.editOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.edit) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.copy) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteOpening(index)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.delete) + "\n                                ")])], 1)]], 2)
  }), 0)])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-2": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary ml-0 mr-3",
    attrs: {
      "disabled": _vm.editingVat || _vm.noTax
    },
    on: {
      "click": _vm.addVat
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.actions.addVat) + "\n                    ")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.noVATtax,
      "hide-details": "",
      "color": "primary"
    },
    model: {
      value: (_vm.noTax),
      callback: function($$v) {
        _vm.noTax = $$v
      },
      expression: "noTax"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.vatRates), function(vat, index) {
    return _c('tr', {
      key: index
    }, [(vat.isEdit) ? [_c('td', [_c('v-text-field', {
      staticClass: "min-w mb-2 required",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.01",
        "required": "",
        "hide-details": "",
        "label": _vm.$lang.actions.addVat
      },
      model: {
        value: (_vm.tempVat.vat),
        callback: function($$v) {
          _vm.$set(_vm.tempVat, "vat", $$v)
        },
        expression: "tempVat.vat"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempVat.vat
      },
      on: {
        "click": function($event) {
          return _vm.saveVatEdit(vat)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$lang.actions.save) + "\n                              ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeVatEdit(vat)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$lang.actions.cancel) + "\n                              ")])], 1)] : [_c('td', [_vm._v(_vm._s(vat.vat))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editVat(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit) + "\n                              ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteVat(index)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$lang.actions.delete) + "\n                              ")])], 1)]], 2)
  }), 0)])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.tipTax,
      "items": _vm.vatRates,
      "type": "number",
      "step": "0.5",
      "min": "0",
      "disabled": _vm.noTipTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.tipTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "tipTaxRate", $$v)
      },
      expression: "company.tipTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noTipTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noTipTax),
      callback: function($$v) {
        _vm.noTipTax = $$v
      },
      expression: "noTipTax"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.chargeTax,
      "items": _vm.vatRates,
      "disabled": _vm.noDeliveryTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.deliveryChargesTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "deliveryChargesTaxRate", $$v)
      },
      expression: "company.deliveryChargesTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noDeliveryTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noDeliveryTax),
      callback: function($$v) {
        _vm.noDeliveryTax = $$v
      },
      expression: "noDeliveryTax"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.back))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.company.address.country === 'AT' ? !_vm.valid2 || !_vm.vatRates || (_vm.vatRates && _vm.vatRates.length === 0) : !_vm.valid2,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.next) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid3),
      callback: function($$v) {
        _vm.valid3 = $$v
      },
      expression: "valid3"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.labels.account) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.holder,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingHolder)); }]
    },
    model: {
      value: (_vm.account.name),
      callback: function($$v) {
        _vm.$set(_vm.account, "name", $$v)
      },
      expression: "account.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.username,
      "hint": _vm.$lang.labels.lowerCase,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingUserName)); }]
    },
    on: {
      "blur": function($event) {
        _vm.account.userName ? _vm.account.userName = _vm.account.userName.toLowerCase().trim() : ''
      }
    },
    model: {
      value: (_vm.account.userName),
      callback: function($$v) {
        _vm.$set(_vm.account, "userName", $$v)
      },
      expression: "account.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.email,
      "type": "email",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.confirmEmail,
      "type": "email",
      "rules": [function (v) { return (!!v && v === _vm.account.email) || ("" + (_vm.$lang.errors.validConfirmEmail)); }]
    },
    model: {
      value: (_vm.confirmEmail),
      callback: function($$v) {
        _vm.confirmEmail = $$v
      },
      expression: "confirmEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.maxDiscountPercentage
    },
    model: {
      value: (_vm.account.maxDiscountPercentage),
      callback: function($$v) {
        _vm.$set(_vm.account, "maxDiscountPercentage", $$v)
      },
      expression: "account.maxDiscountPercentage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.notes
    },
    model: {
      value: (_vm.account.notes),
      callback: function($$v) {
        _vm.$set(_vm.account, "notes", $$v)
      },
      expression: "account.notes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.back))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid3,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.submit) + "\n              ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addressDialog) ? _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "max-width": "600px"
    },
    model: {
      value: (_vm.addressDialog),
      callback: function($$v) {
        _vm.addressDialog = $$v
      },
      expression: "addressDialog"
    }
  }, [_c('address-modal', {
    attrs: {
      "country": _vm.company.address.country,
      "address": _vm.company.address,
      "postal": _vm.company.address.postalcode
    },
    on: {
      "close": function($event) {
        _vm.addressDialog = false
      },
      "submit": _vm.submitAddress
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a123387","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUp.vue
// module id = 399
// module chunks = 35